export const SUCCESS_MESSAGE = 'Thanks for Subscribing';
export const FAILURE_MESSAGE = 'Something went wrong. Please try again later.';
export const BUTTON_TEXT = 'Send';
export const ACC_ERROR_MESSAGE = 'Provide a valid email as for eg: abc@123.com';
